module.exports = __webpack_public_path__ + "img/603-42dfb3.png";